import React, { useState, useEffect } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

// Helper function to extract the video ID from a YouTube link
const extractVideoId = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|embed\/|watch\?v=|watch\?.+&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
};

const ImageCarousel = ({ product }) => {

    const [centerSlidePercentage, setCenterSlidePercentage] = useState(50);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 1024) {
                setCenterSlidePercentage(100);
            } else {
                setCenterSlidePercentage(50);
            }
        };

        // Set initial value
        handleResize();

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Parse the stringified array of S3 links, assuming it is a valid JSON string.
    let images = [];
    let videos = [];

    try {
        images = product?.images ? product.images.split(',').map(url => url.trim()) : [];
        if (images.length > 0 && images[0] === "") {
            images = [];
        }
    } catch (error) {
        console.error('Error parsing images:', error);
    }

    try {
        // Ensure videos is a valid string before processing
        let videoString = product?.videos?.trim() || "";
        // Split the string by commas, trim spaces, and filter out empty entries
        videos = videoString
            .split(',')
            .map(url => url.trim())
            .filter(url => url !== ""); // Remove any empty strings caused by trailing commas

    } catch (error) {
        videos = []; // Ensure videos is initialized as an empty array in case of an error
    }

    // State to manage the current slide.
    const [currentIndex, setCurrentIndex] = useState(0);

    // Combine images and videos for a unified array
    const mediaItems = [
        ...videos.map((vid) => ({ type: 'video', src: vid })),
        ...images.map((img) => ({ type: 'image', src: img }))
    ];

    // Return null (renders nothing) if there are no images or videos
    if (mediaItems.length === 0) {
        return null;
    }

    return (
        <div className="md:mt-5 w-full">
            <Carousel
                selectedItem={currentIndex}
                onChange={(index) => setCurrentIndex(index)}
                centerMode={true}  // Enables center mode
                centerSlidePercentage={centerSlidePercentage}
                infiniteLoop={false}  // Enable infinite loop
                showThumbs={false}  // Hide thumbnails if not needed
                showStatus={false}  // Hide status info (e.g., "1 of 3")
                showIndicators={true}  // Show indicators if needed
                autoPlay={false}  // Optional: Enable autoplay if desired
            >
                {mediaItems.map((media, index) => (
                    <div key={index} className="flex items-center justify-center h-full">
                        {media.type === 'image' ? (
                            <div className="h-full w-full">
                                <img src={media.src} alt={`Product Image ${index + 1}`} className="w-full h-[300px] md:h-[400px] lg:max-w-[85%] lg:min-h-[300px] lg:max-h-[300px] object-cover" />
                            </div>
                        ) : (
                            <div className="h-full w-full">
                                <iframe
                                    className="w-full h-[300px] md:h-[400px] lg:h-[300px] "
                                    src={`https://www.youtube.com/embed/${extractVideoId(media.src)}`}
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    title={`Product Video ${index + 1}`}
                                />
                            </div>
                        )}
                    </div>
                ))}
            </Carousel>
        </div>
    );
};

export default ImageCarousel;